/**
 * Class strings for the two emphasised buttons of the Dusk theme, shared by
 * the connect screens. Both are written as plain strings with the edge layer
 * tokens, so they read the same in either theme and never name one.
 *
 * `cn` (utils) knows `border-edge` and the lit shadows, so passing these as a
 * Button's `className` keeps them against the variant's own classes.
 */

/** The main call to action, from the --cta tokens: a purple gradient in light, white in Dusk. */
export const ctaButtonClass =
  "border-cta-w border-cta-edge bg-cta bg-cta-image text-cta-foreground shadow-cta hover:bg-cta hover:[filter:var(--cta-hover)] active:[filter:var(--cta-active)]";

/**
 * The second emphasised button, in place of the Button's `secondary` variant.
 * Light keeps the gradient and drops the edge, because the hard outline and
 * shadow belong to the main button above. Dusk keeps its hairline and halo:
 * that one is a gradient of --hb-blue, which is lightened in Dusk and cannot
 * carry its white label there, and its shadow would sit beside the lit one.
 * Use it on the default variant. The plain fill displaces the variant's own
 * `bg-primary`, and the gradient sits over it; the hover fill displaces
 * `hover:bg-primary/90`, which would otherwise tint the gradient.
 */
export const raisedButtonClass =
  "border border-transparent bg-hb-blue-fill bg-dusk-tile-a text-white hover:bg-hb-blue-fill hover:brightness-110 dark:border-edge dark:border-lit-edge dark:shadow-lit dark:hover:shadow-lit-strong";
